import { getLang } from '@bark/bark-core/src/helpers/locale';

class WhatIsBarkModal {
	constructor() {}
	init() {
		this.bindEvents();
	}
	bindEvents() {
		var modal = this;

		$('#whatIsBarkModal .nav-link').on('click', function () {
			var self = $(this);
			modal.makeActive(self);

			var target = $(this).data('target');
			modal.showPanel(target);
		});

		$('#whatIsBarkModal').on('show.bs.modal', function () {
			var hash = window.location.hash;

			if (hash && hash !== '#') {
				modal.showPanel(hash);

				modal.makeActive(
					$('#whatIsBarkModal .nav-link[data-target="' + window.location.hash + '"]'),
				);
			}
		});
	}
	makeActive(target) {
		$('#whatIsBarkModal .nav-link').removeClass('active');
		target.addClass('active');
	}
	showPanel(target) {
		$('#whatIsBarkModal .tab-panel').addClass('d-none').removeClass('show');

		$(target).addClass('show');
		$(target).removeClass('d-none');
	}
}

export default function () {
	if ($('#whatIsBarkModal').length > 0) {
		new WhatIsBarkModal().init();
	}
}

export const whatIsBarkTestimonialVideosJs = () => {
	var barkModalOpen = false;

	$('.comment-card .avatar-wrapper').click(function () {
		if (getLang() !== 'en') return;
		var videoSrc = $(this).data('src');

		barkModalOpen = ($('#whatIsBarkModal').data('bs.modal') || {})._isShown;

		if (videoSrc) {
			var videoModal = $('#videoModal');

			if (barkModalOpen) {
				$('#whatIsBarkModal').modal('hide');
			}

			videoModal.modal('show');
			videoModal.find('#video-iframe').attr('src', videoSrc);
		}
	});

	$('#videoModal').on('hide.bs.modal', function (e) {
		$(this).find('#video-iframe').attr('src', '');
		if (barkModalOpen) {
			$('#whatIsBarkModal').modal('show');
		}
	});
};
